import React from 'react';

const HIGHLIGHT_STYLE: React.CSSProperties = {
  color: '#f2c94c',
  fontWeight: 700,
};

const IntentFactBanner: React.FC = () => (
  <div
    className="d-flex align-items-center mb-3"
    style={{
      background: 'linear-gradient(90deg, #2f2350, #3d2f66)',
      color: '#fff',
      borderRadius: 8,
      padding: '1rem 1.5rem',
      gap: '1.5rem',
    }}
  >
    <div
      className="text-center flex-shrink-0"
      style={{
        paddingRight: '1.5rem',
        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <div style={{ fontSize: '2rem', fontWeight: 700, lineHeight: 1 }}>
        ≈200×
      </div>
      <div
        className="text-uppercase"
        style={{ fontSize: '0.65rem', letterSpacing: '0.05em' }}
      >
        Más probable de ofertar
      </div>
    </div>
    <div style={{ fontSize: '0.9rem', lineHeight: 1.5 }}>
      Un inversionista que agenda <strong style={HIGHLIGHT_STYLE}>visita o asesoría</strong>{' '}
      tiene ~200× más probabilidad de llegar a{' '}
      <strong style={HIGHLIGHT_STYLE}>reserva u oferta</strong> que el resto. Cuando
      escala, lo hace en <strong style={HIGHLIGHT_STYLE}>~16 horas promedio</strong> — el
      seguimiento del mismo día vale más que el de la próxima semana. Si además tiene{' '}
      <strong style={HIGHLIGHT_STYLE}>favoritos ❤</strong>, está comparando: pregúntale
      por ellos.
    </div>
  </div>
);

export default IntentFactBanner;
